define('modules/private/view-mdfooter',['require','exports','module','jquery','backbone','i18n','react','react-dom','mdfooterjs','ThemesHelper'],function (require, exports, module) {
  "use strict";

  var $ = require("jquery"),
    Backbone = require("backbone"),
    i18n = require("i18n"),
    React = require("react"),
    ReactDOM = require("react-dom"),
    MDFooter = require("mdfooterjs"),
    ThemesHelper = require("ThemesHelper");

  var MDFooterJS = Backbone.View.extend({
    initialize: function (options) {
      this.options = options;
    },

    render: function () {
      if (!$.isEmptyObject(ReactDOM)) {
        ReactDOM.render(
          React.createElement(MDFooter, {
            theme: ThemesHelper.getCurrentTheme(),
            lang: i18n.lng(),
          }),
          document.getElementById("footer")
        );

        if (this.options.afterRenderCallback) {
          this.options.afterRenderCallback();
        }
      }
    },
  });

  module.exports = MDFooterJS;
});

